import { ProgressListItem } from "../model/ProgressList.js";

export class SoundOptions {
    context: AudioContext;
}

export class Sound {
    public readonly buffer: AudioBuffer;
    public readonly context: AudioContext;
    public channel: Float32Array = null;

    private _current: AudioBufferSourceNode;

    constructor(options: SoundOptions) {
        this.context = options.context;
    }

    public load(url: string,
        context: string,
        progress?: ProgressListItem,
        conversion?: ProgressListItem): Promise<Sound> {
        return new Promise<Sound>(
            (resolve, reject) => {

                if (!url) {
                    reject(new Error("Could not load sound from empty url. " + context));
                    return;
                }

                const request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.responseType = 'arraybuffer';
                request.onprogress = (e) => {
                    // console.log(e);

                    if (progress
                        && e.lengthComputable) {
                        progress.update(e.loaded, e.total);
                    }
                };
                request.onload = (evt) => {

                    // this.buffer = {
                    //     duration: 60000
                    // }
                    // resolve(this);
                    // return;

                    // var response = JSON.parse(request.responseText);
                    if (request.status !== 200) {
                        // console.log("AHHH", request.status);
                        reject(new Error("Could not load sound: " + url));
                        return;
                    }


                    let count = 0;
                    let arrayBuffer: ArrayBuffer = request.response;

                    if (progress) {
                        // console.log("LOADED...", arrayBuffer.byteLength);
                        progress.update(arrayBuffer.byteLength, arrayBuffer.byteLength);
                    }

                    let clone = arrayBuffer.slice(0, arrayBuffer.byteLength);

                    this.context.decodeAudioData(
                        arrayBuffer,
                        (buffer: AudioBuffer) => {

                            this.setBuffer(buffer);

                            count++;

                            if (count == 2) {
                                if (conversion) {
                                    conversion.update(1, 1);
                                }
                                resolve(this);
                            }
                        },
                        (error) => {
                            console.error(error);
                            // e5.Toast.showText(error + "");
                            reject(error);
                        });

                    this.context.decodeAudioData(
                        clone,
                        (buffer: AudioBuffer) => {
                            clone = null;

                            this.createSoundwaveData(buffer);

                            count++;
                            if (count == 2) {
                                if (conversion) {
                                    conversion.update(1, 1);
                                }
                                resolve(this);
                            }
                        },
                        (error) => {
                            console.error(error);
                            // e5.Toast.showText(error + "");
                            reject(error);
                        });

                    // this.context.decodeAudioData(
                    //     arrayBuffer,
                    //     (buffer: AudioBuffer) => {
                    //         this.setBuffer(buffer);
                    //         this.createSoundwaveData(buffer);
                    //         conversion.update(1, 1);
                    //         resolve(this);
                    //     });
                };
                request.send();
            }
        );
    }

    private createSoundwaveData(buffer: AudioBuffer): void {
        // clone = null;
        // const steps = 8192;

        const samplesPerSecond = 32;
        const sampleRange = 1 / samplesPerSecond;

        const sampleOffset = (1 - sampleRange * 0.5);
        const samplesPerStep = buffer.duration * samplesPerSecond;
        const result = new Float32Array(samplesPerStep);

        // console.log(buffer.numberOfChannels);

        const countChannels = buffer.numberOfChannels;
        for (let step = 0; step < samplesPerStep; ++step) {
            let value = 0;
            var samples = 0;
            for (let i = 0; i < countChannels; ++i) {
                const channel = buffer.getChannelData(i);

                // var idx = Math.floor((step / steps) * channel.length);
                // value = Math.max(value, channel[idx], 0);

                let start = Math.floor((step / samplesPerStep) * channel.length + sampleOffset);
                let end = start + Math.floor((channel.length / samplesPerStep) * sampleRange);
                for (let k = start; k < end; ++k) {
                    value = Math.max(value, channel[k] || 0, 0);
                }

                // var start = Math.floor((step / steps) * channel.length);
                // var end = start + Math.floor((channel.length / steps));
                // for (var k = start; k < end; ++k) {
                //     value = Math.max(value, channel[k] || 0, 0);
                // }

                // var start = Math.floor((step / steps) * channel.length);
                // var end = start + Math.floor(channel.length / steps);
                // for (var k = start; k < end; ++k) {
                //     value += Math.max(channel[k] || 0, 0);
                //     samples++;
                // }
            }

            result[step] = value;
            // result[step] = value / samples;
        }

        (this as Mutable<Sound>).channel = result;


    }

    // public load(url: string): Promise<Sound> {
    //     return new Promise<Sound>(
    //         (resolve, reject) => {
    //             e5.load("audiobuffer", url, {
    //                 audioContext: this.context
    //             }).then((buffer) => {
    //                 this.setBuffer(buffer);
    //                 resolve(this);
    //             });
    //         }
    //     );
    // }

    public once(killOld: boolean, when: number = 0): void {

        if (killOld && this._current) {
            this._current.onended = null;
            this._current.stop();
            this._current.disconnect();
            this._current = null;
        }

        let source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.onended = () => {
            source.onended = null;
            source.stop();
            source.disconnect();
            if (this._current === source) {
                this._current = null;
            }
            source = null;
        }
        source.connect(this.context.destination);
        source.start(when);
        this._current = source;
    }

    // public once(): void {
    //     let source = this.context.createBufferSource();
    //     source.buffer = this.buffer;
    //     source.onended = () => {
    //         source.onended = null;
    //         source.stop();
    //         source.disconnect();
    //         source = null;
    //     }
    //     source.connect(this.context.destination);
    //     source.start();
    // }

    private setBuffer(buffer: AudioBuffer): void {
        (this as Mutable<Sound>).buffer = buffer;

        /**
         * !!! NEVER DO THAT -> THAT WILL DOUBLE THE MEMORY USAGE !!!
         */
        // for (let i = 0; i < this.buffer.numberOfChannels; ++i) {
        //     /**
        //      * Bug in Firefox ... without slice the Float32Array 
        //      * length will be zero after GC!
        //      */
        //     this.channels.push(this.buffer.getChannelData(i).slice());
        // }
    }
}